import axios from 'axios';


export const getUser = async () => {
   const response = await axios.get(`/auth/isloggedin`);
   return response.data;
}

export const getUserSocket = async () => {
   const response = await axios.get(`/api/socket`);
   return response.data;
}
